'use client';

import { use } from 'react';

import { Or2AnalyticsContext } from '@/context/Or2AnalyticsContext';

export const useTrackIntercomEvent = () => {
  const { analytics } = use(Or2AnalyticsContext);

  return (
    eventName: string,
    metaData: Record<string, string | boolean | number | null | undefined> = {},
  ) => {
    if (!analytics) return;

    const cleanedMetaData = Object.fromEntries(
      Object.entries(metaData).filter(
        (entry): entry is [string, string | boolean | number] =>
          entry[1] !== undefined && entry[1] !== null,
      ),
    );

    analytics.track(eventName, cleanedMetaData);
  };
};
